module.exports = __webpack_public_path__ + "feedback.0b0aec88.svg";